/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/27/19
 * Time: 9:56 AM
 */
import * as actionTypes from '../Action/actionTypes';
import mr_icon from "../../assets/img/recept_checkin/man.svg";
import mrs_icon from "../../assets/img/recept_checkin/girl.svg";
import purpose_icon from "../../assets/img/recept_checkin/purpose.svg";
import users_icon from "../../assets/img/recept_checkin/users.svg";

const initialState = {
  custom_visitors_list: [],
  all_building_list: [],
  all_wifi_packages_list: [],
  all_floor_list: [],
  all_available_card: [],
  visitors_title_list: [
    {
      key: 0,
      text: 'Mr.',
      value: 'Mr',
      image: {avatar: true, src: mr_icon},
    },
    {
      key: 1,
      text: 'Mrs.',
      value: 'Mrs',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 2,
      text: 'Miss.',
      value: 'Miss',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 3,
      text: 'Ms.',
      value: 'Ms',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 4,
      text: 'Dr.',
      value: 'Dr',
      image: {avatar: true, src: users_icon},
    },

    {
      key: 5,
      text: 'Ven.',
      value: 'Ven',
      image: {avatar: true, src: users_icon},
    },
  ],
  visitors_purpose_options_list: [
    {
      key: 1,
      text: 'Payment Collection',
      value: 'Payment Collection',
      image: {avatar: true, src: purpose_icon},
    },
    {
      key: 2,
      text: 'Business',
      value: 'Business',
      image: {avatar: true, src: purpose_icon},
    },
    {
      key: 3,
      text: 'Interview',
      value: 'Interview',
      image: {avatar: true, src: purpose_icon},
    },
    {
      key: 4,
      text: 'Meeting',
      value: 'Meeting',
      image: {avatar: true, src: purpose_icon},
    },
    {
      key: 5,
      text: 'Investigation',
      value: 'Investigation',
      image: {avatar: true, src: purpose_icon},
    },
    {
      key: 6,
      text: 'Personal',
      value: 'Personal',
      image: {avatar: true, src: purpose_icon},
    },
  ],

  building_col: [
    {
      label: 'Requested',
      field: 'host_1'
    },
    {
      label: 'Assign To',
      field: 'host_2'
    },
    {
      label: 'Building',
      field: 'building'
    },
    {
      label: 'Floor',
      field: 'floor'
    },
    {
      label: 'Pass Number',
      field: 'code'
    },
    {
      label: 'Remove',
      field: 'remove'
    }
  ],
  visitors_col: [
    {
      label: 'Identity',
      field: 'id'
    },
    {
      label: 'Mobile',
      field: 'mobile'
    },
    {
      label: 'First Name',
      field: 'fname'
    },
    {
      label: 'Last Name',
      field: 'lname'
    },
    {
      label: 'Pass Number',
      field: 'pass'
    },
    {
      label: 'Vehicle No',
      field: 'vehicleNo'
    },
    {
      label: 'Children',
      field: 'children',
      sort: 'asc'
    },
    {
      label: 'Remove',
      field: 'remove'
    }
  ],
  visitors_offline_col:  [
    {
      label: 'Row Number',
      field: 'index'
    },
    {
      label: 'Host A - Mobile',
      field: 'hostAMobile'
    },
    {
      label: 'Host B - Mobile (optional)',
      field: 'hostBMobile'
    },
    {
      label: 'Building',
      field: 'buildingName'
    },
    {
      label: 'Floor',
      field: 'floorName'
    },
    {
      label: 'Pass Number',
      field: 'cardName'
    },
    {
      label: 'Visiting Purpose',
      field: 'visitingPurpose'
    },
    {
      label: 'Identification Number',
      field: 'identificationValue'
    },
    {
      label: 'First Name',
      field: 'firstName'
    },
    {
      label: 'Last Name',
      field: 'lastName'
    },
    {
      label: 'Title',
      field: 'title'
    },
    {
      label: 'Email (optional)',
      field: 'email'
    },
    {
      label: 'Mobile',
      field: 'mobile'
    },
    {
      label: 'Company (optional)',
      field: 'companyName'
    },
    {
      label: 'CheckInDate',
      field: 'checkInDate'
    },
    {
      label: 'CheckOutDate',
      field: 'checkOutDate'
    },
    {
      label: 'RefNo',
      field: 'refNo'
    },
  ],
  visitors_offline_errors_lists:  [
    {
      label: 'Row Number',
      field: 'row'
    },
    {
      label: 'Error Message',
      field: 'message'
    },
    ]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {


    case actionTypes.CUSTOM_VISITORS:
      return {
        ...state,
        custom_visitors_list: action.value
      };

    case actionTypes.ALL_BUILDINGS:
      return {
        ...state,
        all_building_list: action.value
      };

    case actionTypes.ALL_WIFI_PACKAGES:
      return {
        ...state,
        all_wifi_packages_list: action.value
      };

    case actionTypes.ALL_FLOORS:
      return {
        ...state,
        all_floor_list: action.value
      };

    case actionTypes.ALL_AVAILABLE_CARDS:
      return {
        ...state,
        all_available_card: action.value
      };

    default:
      return state;
  }
};

export default reducer;
